import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { FaArrowLeft, FaMapMarkerAlt, FaPlus, FaEdit, FaTrash } from 'react-icons/fa';

const Container = styled.div`
  padding: 1rem;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 16px;
  cursor: pointer;
  padding: 0.5rem 0;
  margin-bottom: 1rem;

  svg {
    font-size: 20px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

const Title = styled.h1`
  font-size: 24px;
  color: var(--text-primary);
  margin: 0;
`;

const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--primary-color-dark);
  }

  svg {
    font-size: 16px;
  }
`;

const AddressList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const AddressCard = styled.div`
  background-color: var(--bg-secondary);
  border-radius: 10px;
  padding: 1.5rem;
  position: relative;
`;

const AddressLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  svg {
    color: var(--primary-color);
  }
`;

const AddressText = styled.div`
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.5;
`;

const ActionButtons = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: flex;
  gap: 0.5rem;
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0.25rem;
  transition: color 0.2s;

  &:hover {
    color: var(--primary-color);
  }

  svg {
    font-size: 16px;
  }
`;

const SavedAddresses: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [addresses] = useState([
    { id: 1, label: 'Maison', address: 'Rue de la Paix 123, 1000 Bruxelles' },
    { id: 2, label: 'Bureau', address: 'Avenue Louise 456, 1050 Bruxelles' },
  ]);

  const handleEdit = (id: number) => {
    // TODO: Implement edit logic
    console.log('Editing address:', id);
  };

  const handleDelete = (id: number) => {
    // TODO: Implement delete logic
    console.log('Deleting address:', id);
  };

  const handleAdd = () => {
    // TODO: Implement add logic
    console.log('Adding new address');
  };

  return (
    <Container>
      <BackButton onClick={() => navigate('/profile')}>
        <FaArrowLeft />
        {t('common.back')}
      </BackButton>

      <Header>
        <Title>{t('profile.savedAddresses')}</Title>
        <AddButton onClick={handleAdd}>
          <FaPlus />
          {t('profile.addAddress')}
        </AddButton>
      </Header>

      <AddressList>
        {addresses.map(address => (
          <AddressCard key={address.id}>
            <AddressLabel>
              <FaMapMarkerAlt />
              {address.label}
            </AddressLabel>
            <AddressText>{address.address}</AddressText>
            <ActionButtons>
              <ActionButton onClick={() => handleEdit(address.id)}>
                <FaEdit />
              </ActionButton>
              <ActionButton onClick={() => handleDelete(address.id)}>
                <FaTrash />
              </ActionButton>
            </ActionButtons>
          </AddressCard>
        ))}
      </AddressList>
    </Container>
  );
};

export default SavedAddresses; 